<main class="msg-page">
  <section class="msg-page__card" aria-live="polite">
    @switch (phase) {
      @case ('done') {
        <div class="msg-page__badge"><mat-icon>task_alt</mat-icon></div>
        <h1 class="msg-page__title">{{strings['email_revert_done_title']}}</h1>
        <p class="msg-page__body">{{ getString(restored ? 'email_revert_done_text' : 'email_revert_kept_text', email) }}</p>
        @if (passwordReset) {
          <p class="msg-page__body">{{ getString('email_revert_reset_sent', email) }}</p>
        }
        <div class="msg-page__actions">
          <button mat-flat-button color="primary" type="button" (click)="signIn()">{{strings['login_sign_in_button']}}</button>
        </div>
      }

      @case ('invalid') {
        <div class="msg-page__badge msg-page__badge--error"><mat-icon>link_off</mat-icon></div>
        <h1 class="msg-page__title">{{strings['email_revert_invalid_title']}}</h1>
        <p class="msg-page__body">{{strings['email_revert_invalid_text']}}</p>
      }

      @default {
        <div class="msg-page__badge msg-page__badge--warn"><mat-icon>gpp_maybe</mat-icon></div>
        <h1 class="msg-page__title">{{strings['email_revert_title']}}</h1>
        <p class="msg-page__body">{{strings['email_revert_text']}}</p>
        @if (phase === 'error') {
          <p class="msg-page__body msg-page__body--error" role="alert">{{strings['error_unknown']}}</p>
        }
        <div class="msg-page__actions">
          <button mat-flat-button color="warn" type="button" [disabled]="phase === 'working'" (click)="undo()">
            {{strings['email_revert_button']}}
          </button>
        </div>
        @if (phase === 'working') {
          <mat-spinner class="msg-page__spinner" diameter="28"></mat-spinner>
        }
      }
    }
  </section>

  <p class="msg-page__foot">Measure Map Online</p>
</main>
